import {formatInteger} from "@/lib/utils";
import {DimensionDTO} from "@/api/data-contracts";
import {LabelValue} from "@/lib/components/LabelValueList";

export const dimensionsField = (
    data: DimensionDTO | null | undefined,
    label: string,
    defaultValue: string = "",
    locale?: string,
    tooltipKey?: string
): LabelValue => {
    const length = data?.length;
    const width = data?.width;
    const height = data?.height;

    const allValuesUndefined = !length && !width && !height;

    const formatDimension = (value?: number | null) => {
        if (value === undefined || value === null) {
            return defaultValue;
        }
        return formatInteger(value, locale) || defaultValue;
    };

    const dimensionString = `${formatDimension(length)} x ${formatDimension(width)} x ${formatDimension(height)} mm`;

    return {
        label,
        value: allValuesUndefined ? defaultValue : dimensionString,
        tooltipKey
    };
};
